<template>
    <div class="fixed">
        <audio id="radioPlayer" ref="radioPlayer" crossorigin="anonymous" playsinline hidden></audio>
        <div class="player-top">
            <button class="playbutton" @click="playPod()" :aria-label="isPlaying ? 'Pause City Radio' : 'Play City Radio'">
                <img v-if="play" src="@/assets/svg/play.svg" alt="">
                <img v-else src="@/assets/svg/pause.svg" alt="">
            </button>
            <div class="now-playing">
                <div class="station-row">
                    <span class="live-badge" :class="{ on: isPlaying }">
                        <span class="dot"></span>
                        {{ isPlaying ? 'Live' : 'Paused' }}
                    </span>
                    <span class="station-name">City Radio</span>
                    <h2 v-if="activeProgram" class="program-title">{{ activeProgram.title }}</h2>
                </div>
                <div class="meta-row">
                    <span class="day">{{ todayDay }}</span>
                    <span v-if="activeProgram" class="program-time">
                        {{ hm(activeProgram.startTime) }} – {{ hm(activeProgram.endTime) }}
                    </span>
                    <span v-else class="on-air">On air now</span>
                    <span v-if="upNext" class="up-next">Next · {{ upNext.title }}</span>
                </div>
            </div>
        </div>
        <div class="audio-preview">
            <canvas ref="canvas"></canvas>
        </div>
    </div>
</template>
<script>
import Hls from 'hls.js'

const STREAM_URL = 'https://media.watch.rw/radio/017ffc0f-3c85-46bd-9262-d034fa587d91/playlist.m3u8'

export default {
    name: 'fixedbar',
    data() {
        return {
            play: true,
            file: 'ikipe yapfubye.mp3',
            activeProgram: null,
            allprograms: [],
        }
    },
    computed: {
        todayDay() {
            let day = new Date().getDay()
            if (day == 0) { return "Sunday" }
            else if (day == 1) { return "Monday" }
            else if (day == 2) { return "Tuesday" }
            else if (day == 3) { return "Wednesday" }
            else if (day == 4) { return "Thursday" }
            else if (day == 5) { return "Friday" }
            else if (day == 6) { return "Saturday" }
        },
        dayPrograms() {
            let vm = this
            return vm.allprograms.filter(program => program.day == vm.todayDay)
        },
        isPlaying() {
            return !this.play
        },
        upNext() {
            const now = new Date()
            const nowTime = now.getHours() + ':' + now.getMinutes()
            const upcoming = this.dayPrograms
                .filter(program => program.startTime > nowTime)
                .slice()
                .sort((a, b) => String(a.startTime).localeCompare(String(b.startTime)))
            return upcoming[0] || null
        }
    },
    mounted() {
        let vm = this
        vm.$getAllPrograms();
        vm.timer = setInterval(() => {
            vm.checkActiveProgram(vm.dayPrograms);
        }, 1000);
        vm.setupStream()
        vm.startVisualizer()
        window.addEventListener('resize', vm.resizeCanvas)
        window.addEventListener('pointerdown', vm.unlockAudio, { once: true })
    },
    beforeUnmount() {
        this.teardownPlayer()
    },
    methods: {
        hm(time) {
            return time.split(':')[0] + ":" + time.split(':')[1]
        },
        checkActiveProgram(dayPrograms) {
            let vm = this
            let now = new Date()
            let nowTime = now.getHours() + ":" + now.getMinutes()
            let activeProgram = dayPrograms.filter(program => program.startTime <= nowTime && program.endTime >= nowTime)
            if (activeProgram.length > 0) {
                vm.activeProgram = activeProgram[0];
            } else {
                vm.activeProgram = false;
            }
        },
        setupStream() {
            const audio = this.$refs.radioPlayer
            if (!audio) return
            audio.crossOrigin = 'anonymous'
            audio.addEventListener('play', () => { this.play = false })
            audio.addEventListener('pause', () => { this.play = true })

            if (Hls.isSupported()) {
                this.hls = new Hls({
                    enableWorker: true,
                    lowLatencyMode: false,
                    liveSyncDurationCount: 3,
                    liveMaxLatencyDurationCount: 8,
                    maxLiveSyncPlaybackRate: 1.2,
                    backBufferLength: 30,
                })
                this.hls.loadSource(STREAM_URL)
                this.hls.attachMedia(audio)
                this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                    this.recoverAttempts = 0
                    this.tryAutoplay()
                })
                this.hls.on(Hls.Events.ERROR, (event, data) => {
                    if (!data.fatal || !this.hls) return
                    this.recoverAttempts = (this.recoverAttempts || 0) + 1
                    if (this.recoverAttempts > 6) return
                    if (data.type === Hls.ErrorTypes.NETWORK_ERROR) {
                        this.hls.startLoad()
                    } else if (data.type === Hls.ErrorTypes.MEDIA_ERROR) {
                        this.hls.recoverMediaError()
                    } else {
                        this.hls.destroy()
                        this.hls = null
                    }
                })
                return
            }

            if (audio.canPlayType('application/vnd.apple.mpegurl')) {
                audio.src = STREAM_URL
                audio.addEventListener('loadedmetadata', () => this.tryAutoplay(), { once: true })
            }
        },
        tryAutoplay() {
            const audio = this.$refs.radioPlayer
            if (!audio) return
            const attempt = audio.play()
            if (attempt) {
                attempt.catch(() => {
                    this.play = true
                })
            }
        },
        unlockAudio() {
            const audio = this.$refs.radioPlayer
            const AudioCtx = window.AudioContext || window.webkitAudioContext
            if (!audio || !AudioCtx) return
            if (!this.context) this.context = new AudioCtx()
            const resumePromise = this.context.resume()
            if (resumePromise && resumePromise.catch) resumePromise.catch(() => {})
            if (this.src) return
            this.src = this.context.createMediaElementSource(audio)
            this.analyser = this.context.createAnalyser()
            this.analyser.fftSize = 256
            this.analyser.smoothingTimeConstant = 0.82
            this.src.connect(this.analyser)
            this.analyser.connect(this.context.destination)
            this.bufferLength = this.analyser.frequencyBinCount
            this.dataArray = new Uint8Array(this.bufferLength)
        },
        startVisualizer() {
            this.visualizerOn = true
            this.resizeCanvas()
            this.renderFrame()
        },
        resizeCanvas() {
            const canvas = this.$refs.canvas
            if (!canvas) return
            this.canvas = canvas
            if (!this.ctx) this.ctx = canvas.getContext('2d')
            const width = canvas.clientWidth
            const height = canvas.clientHeight
            if (!width || !height) return
            const ratio = window.devicePixelRatio || 1
            canvas.width = Math.floor(width * ratio)
            canvas.height = Math.floor(height * ratio)
            this.ctx.setTransform(ratio, 0, 0, ratio, 0, 0)
            this.WIDTH = width
            this.HEIGHT = height
        },
        renderFrame() {
            if (!this.visualizerOn) return
            this.animationId = requestAnimationFrame(() => this.renderFrame())
            if (!this.ctx || !this.WIDTH || !this.HEIGHT) {
                this.resizeCanvas()
                return
            }

            const audio = this.$refs.radioPlayer
            const playing = !!(audio && !audio.paused && !audio.ended)
            this.ctx.clearRect(0, 0, this.WIDTH, this.HEIGHT)
            if (!playing) return

            const live = this.analyser && this.dataArray && this.context && this.context.state === 'running'
            if (live) this.analyser.getByteFrequencyData(this.dataArray)

            const bars = this.WIDTH < 480 ? 24 : this.WIDTH < 900 ? 36 : 48
            const gap = this.WIDTH < 480 ? 2 : 3
            const barWidth = Math.max(2, (this.WIDTH - gap * (bars - 1)) / bars)
            let x = 0
            const now = performance.now() / 1000

            for (let i = 0; i < bars; i++) {
                let byte
                if (live) {
                    const index = Math.floor((i / bars) * this.bufferLength)
                    byte = this.dataArray[index]
                } else {
                    const wave = Math.abs(Math.sin(now * 3.2 + i * 0.37))
                    const wave2 = Math.abs(Math.sin(now * 1.4 + i * 0.15))
                    byte = 50 + (wave * 0.7 + wave2 * 0.3) * 170
                }
                const barHeight = Math.max(2, (byte / 255) * this.HEIGHT)
                const r = byte + (2 * (i / bars))
                const g = 100 * (i / bars)
                const b = 100
                this.ctx.fillStyle = `rgb(${r}, ${g}, ${b})`
                this.ctx.fillRect(x, this.HEIGHT - barHeight, barWidth, barHeight)
                x += barWidth + gap
            }
        },
        playPod() {
            const audioPlayer = this.$refs.radioPlayer || document.getElementById('radioPlayer')
            if (!audioPlayer) return
            const shouldPlay = audioPlayer.paused
            document.querySelectorAll('audio').forEach(aud => {
                aud.pause()
            })
            if (shouldPlay) {
                this.unlockAudio()
                const attempt = audioPlayer.play()
                if (attempt) {
                    attempt.catch(() => {
                        this.play = true
                    })
                }
            }
        },
        teardownPlayer() {
            this.visualizerOn = false
            if (this.animationId) cancelAnimationFrame(this.animationId)
            if (this.timer) clearInterval(this.timer)
            window.removeEventListener('resize', this.resizeCanvas)
            window.removeEventListener('pointerdown', this.unlockAudio)
            if (this.hls) {
                this.hls.destroy()
                this.hls = null
            }
            if (this.context) {
                this.context.close()
                this.context = null
            }
        }
    }
}
</script>
<style lang="scss">
:root {
    --radio-player-height: 46px;
}

.fixed {
    width: auto;
    position: fixed;
    z-index: 99999;
    right: 0;
    bottom: 0;
    left: 260px;
    box-sizing: border-box;
    height: var(--radio-player-height);
    padding: 4px 10px;
    background: #dedede;
    border-top: 2px solid #5c689e50;
    color: #0e142aad;
    display: flex;
    align-items: center;
    gap: 10px;

    @media (max-width: 1070px) {
        left: 0;
    }

    .player-top {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
        flex: 1 1 auto;
    }

    .playbutton {
        all: unset;
        width: 28px;
        height: 28px;
        cursor: pointer;
        border-radius: 100%;
        background: #0E142A;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 12px;
            height: 12px;
        }
    }

    .now-playing {
        min-width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 1px;
    }

    .station-row,
    .meta-row {
        display: flex;
        align-items: center;
        gap: 6px;
        min-width: 0;
    }

    .live-badge {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        flex-shrink: 0;
        padding: 2px 7px;
        border-radius: 999px;
        background: #0E142A14;
        color: #0E142A;
        font-size: 0.65rem;
        font-weight: 700;
        letter-spacing: 0.04em;
        text-transform: uppercase;

        .dot {
            width: 6px;
            height: 6px;
            border-radius: 100%;
            background: #8d93a8;
        }

        &.on {
            background: #067a6a18;
            color: #067a6a;

            .dot {
                background: #067a6a;
                box-shadow: 0 0 0 0 #067a6a88;
                animation: live-pulse 1.6s infinite;
            }
        }
    }

    .station-name,
    .day,
    .up-next,
    .program-time {
        font-size: 0.72rem;
        white-space: nowrap;
    }

    .station-name {
        font-weight: 700;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: #0E142A;
    }

    .day,
    .up-next {
        color: #0e142a99;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .program-title {
        margin: 0;
        font-size: 0.75rem;
        font-weight: 700;
        line-height: 1.1;
        text-transform: uppercase;
        color: #0E142A;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0;
        flex: 1;
    }

    .on-air {
        font-size: 0.72rem;
        color: #0e142a99;
        white-space: nowrap;
    }

    .program-time {
        color: #067a6a;
        font-weight: 600;
        flex-shrink: 0;
    }

    .up-next {
        flex: 1;
        min-width: 0;
    }

    .audio-preview {
        position: relative;
        flex: 1 1 160px;
        min-width: 72px;
        height: 32px;
        border-radius: 6px;
        overflow: hidden;
        background: #e7e7e7;

        canvas {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            background: transparent !important;
        }
    }

    @media (max-width: 1070px) {
        .up-next,
        .day {
            display: none;
        }

        .audio-preview {
            flex-basis: 96px;
            min-width: 64px;
        }
    }

    @media (max-width: 570px) {
        .on-air {
            display: none;
        }
    }
}

@keyframes live-pulse {
    0% {
        box-shadow: 0 0 0 0 #067a6a88;
    }

    70% {
        box-shadow: 0 0 0 6px #067a6a00;
    }

    100% {
        box-shadow: 0 0 0 0 #067a6a00;
    }
}
</style>